/**
 * Umami analytics helper.
 *
 * Usage:
 *   import { trackEvent } from '../services/analytics';
 *   trackEvent('signup_started');
 *   trackEvent('audit_completed', { score: 85 });
 *
 * Safe to call even if Umami script hasn't loaded — fails silently.
 */

export function trackEvent(eventName, data = {}) {
  try {
    if (typeof window !== 'undefined' && window.umami) {
      window.umami.track(eventName, data);
    }
  } catch {
    // Silently ignore — analytics should never break the app
  }
}
